<template>
  <div class="com-frame">
    <div class="left-frame">

      <ul class="h-menu menu-custom h-menu-mode-vertical">
        <li v-for="(menuItem,index) in dataList"  class="h-menu-li h-menu-first-level" @click="menuClick(menuItem,index)" :ref="el => { if (index === selectedIndex) selectedEl = el }">
          <div :class="'h-menu-show' + ((index==selectedIndex)?' h-menu-li-selected':'')">
            <i v-if="index==selectedIndex" class="fa fa-hand-o-right" style="position:absolute;left:8px;"></i>
            <span class="h-menu-show-icon">
              {{ index +1 }} 、<i :class="menuItem.icon"></i>
            </span>
            <Tooltip :content="menuItem.title" placement="top-start">
            <span class="h-menu-show-desc" >{{ menuItem.title }}</span>
            </Tooltip>
          </div>
        </li>
      </ul>

    </div>
    <div class="right-frame">

      <img v-if="selectedMenu.type=='img'" :src="selectedMenu.url+'#navpanes=0'" title="" style="width:100%;height:100%;" />
      <iframe v-else :src="selectedMenu.url+'#navpanes=0'" title="" style="width:100%;height:100%;" />

    </div>

  </div>
</template>

<script>
  export default {
    name: "VoucherAttachmentList",
    props: {
      billList: Array
    },
    data(){
      return{
        dataList: [],
        selectedIndex: 0,
        selectedEl: null,
        selectedMenu: {
          title: '',
          key: '',
          type: 'pdf',
          icon: 'fa fa-file-pdf-o',
          url:''
        },
      }
    },
    created() {
      this.loadList();
    },
    mounted() {
      // 挂载键盘监听
      window.addEventListener('keydown', this.handleKeyDown)
    },
    beforeDestroy() {
      // 销毁移除监听，避免污染父页面
      window.removeEventListener('keydown', this.handleKeyDown)
    },
    methods: {
      loadList(){
        console.log(this.billList)
        for (let i = 0; i < this.billList.length; i++) {
          let item = this.billList[i];
          let menu = {
            title: '',
            key: '',
            type: 'pdf',
            icon: 'fa fa-file-pdf-o',
            url:''
          };
          menu.title = item.name;
          menu.key = item.uid;
          switch(item.type){
            case "application/pdf":
              menu.icon = 'fa fa-file-pdf-o';
              menu.type = 'pdf';
              break;
            case "image/jpeg":
            case "image/png":
            case "image/bmp":
            case "image/gif":
              menu.icon = 'fa fa-file-image-o';
              menu.type = 'img';
              break;
            case "text/plain":
              menu.icon = 'fa fa-file-text-o';
              menu.type = 'txt';
              break;
            case "application/msword":
            case "application/vnd.ms-excel":
              menu.icon = 'fa fa-file-excel-o';
              menu.type = 'excel';
              break;
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
              menu.icon = 'fa fa-file-word-o';
              menu.type = 'word';
              break;
            case "application/vnd.ms-powerpoint":
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
              menu.icon = 'fa fa-file-powerpoint-o';
              menu.type = 'ppt';
              break;
            case "application/x-zip-compressed":
              menu.icon = 'fa fa-file-zip-o';
              menu.type = 'zip';
              break;
            default:
              menu.icon = 'fa fa-file-pdf-o';
              menu.type = 'pdf';
          }

          if(item.isExternalLink){
            menu.url = item.url
          }else{
            menu.url = '/api'+item.url+'?name='+item.name
          }

          if(i==0){
            this.selectedMenu = menu;
          }

          this.dataList.push(menu)
        }
      },
      menuClick(data,index){
        this.selectedMenu = data;
        this.selectedIndex = index;

      },
      // 键盘事件
      handleKeyDown(e) {
        // 上箭头
        if (e.key === 'ArrowUp') {
          e.preventDefault() // 阻止页面滚动
          this.prevMenu()
        }
        // 下箭头
        if (e.key === 'ArrowDown') {
          e.preventDefault()
          this.nextMenu()
        }
      },
      prevMenu(){
        if(this.selectedIndex >0 ){
          this.selectedIndex--;
          this.selectedMenu = this.dataList[this.selectedIndex];
          this.$nextTick(() => {
            this.scrollToSelected()
          })

        }
      },
      nextMenu(){
        if(this.selectedIndex < this.dataList.length - 1){
          this.selectedIndex++;
          this.selectedMenu = this.dataList[this.selectedIndex];
          this.$nextTick(() => {
            this.scrollToSelected()
          })
        }
      },
      // 滚动到当前选中元素
      scrollToSelected() {
        if (this.selectedEl) {
          this.selectedEl.scrollIntoView({
            behavior: 'smooth', // 平滑滚动
            block: 'nearest'    // 元素尽量居中/靠最近边
          })
        }
      },
    },
  }
</script>

<!--<script setup>-->

<!--  import voucher from "@/api/voucher";-->
<!--  import {h, ref} from "vue";-->
<!--  import {confirm, message} from "heyui.ext";-->
<!--  import {layer} from "@layui/layer-vue";-->
<!--  const props = defineProps(['billList']);-->
<!--  const loading = ref(false)-->
<!--  const dataList = ref([])-->
<!--  const emits = defineEmits(['close', 'success']);-->
<!--  const pdfUrl = ref();-->
<!--  const fileMenu = ref();-->

<!--  const loadList = () => {-->
<!--    loading.value = true;-->
<!--    dataList.value =  [-->

<!--    ]-->
<!--    // voucher.tpl().then(({data}) => {-->
<!--    //   dataList.value = data;-->
<!--    //-->
<!--    // }).finally((() => loading.value = false))-->

<!--    for (let i = 0; i < props.billList.length; i++) {-->
<!--      let item = props.billList[i];-->
<!--      let menu = {-->
<!--        title: '',-->
<!--        key: '',-->
<!--        icon: 'fa fa-file-pdf-o',-->
<!--        url:''-->
<!--      };-->
<!--      menu.title = item.name;-->
<!--      menu.key = item.uid;-->
<!--      switch(item.type){-->
<!--        case "application/pdf":-->
<!--          menu.icon = 'fa fa-file-pdf-o';-->
<!--      }-->

<!--      if(item.isExternalLink){-->
<!--        menu.url = item.url-->
<!--      }else{-->
<!--        menu.url = '/api'+item.url+'?name='+item.name-->
<!--      }-->

<!--      if(i==0){-->
<!--        pdfUrl.value = menu.url;-->
<!--      }-->

<!--      dataList.value.push(menu)-->
<!--    }-->
<!--  }-->

<!--  const menuClick = (data) => {-->
<!--    pdfUrl.value = data.url;-->
<!--  }-->
<!--  loadList();-->

<!--</script>-->

<style lang="less" >

.menu-custom {
  .h-menu {
    &-show {
      color: @blue-color;
      &:hover {
        // background: @yellow-color;
        color: @primary-color;;
      }
    }
    &-li {
      &-selected {
        font-weight: bold;
        // background: @yellow-color;
        color: @primary-color;;
      }
    }
  }
}
.com-frame {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.com-frame .left-frame {
  position: absolute;
  z-index: 2;
  overflow: auto;
  bottom: 0;
  top: 0;
  width: 280px;
  padding: 10px 0 10px;
  line-height: 2.5;
  border-right:1px solid #f0f0f0;
}
.com-frame .right-frame {
  position: absolute;
  left: 280px;
  right: 0;
  bottom: 0;
  top: 0;
  padding: 0 0 5px 0;
  overflow: auto;
  z-index: 1;
}

</style>
